import type { Tone } from "../../components/ui";
import type { QuoteStatus } from "./types";

// Un estado, un tono (skill estados-y-tonos). `primary` nunca es un estado y
// lo desconocido se pinta neutral.
export const QUOTE_STATUS_TONES = {
  draft: "neutral",
  sent: "info",
  accepted: "success",
  rejected: "error",
  expired: "neutral",
} as const satisfies Record<QuoteStatus, Tone>;

export function quoteStatusTone(status: string | null | undefined): Tone {
  return (QUOTE_STATUS_TONES as Record<string, Tone>)[status ?? ""] ?? "neutral";
}

export const TOLLS_SOURCE_TONES = {
  google: "info",
  manual: "neutral",
  none: "neutral",
  unavailable: "warning",
} as const satisfies Record<string, Tone>;
